import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const mutationFinancialAccountSyncTransactionsAtom =
  createMutationAtomFactory(
    'finance.financialAccountSyncTransactions',
    (_: void) => ({
      financeFinancialAccountSyncTransactions: true,
    }),
  );
